














 





















































































































































































































































































































































const node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fieldName",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preferredName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v5 = [
  (v1/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "RemoveTeamMemberPayload",
  "kind": "LinkedField",
  "name": "RemoveTeamMemberPayload",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "updatedTasks",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plaintextContent",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "createdByUser",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueDate",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v17 = {
  "alias": "ghUrl",
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    (v17/*: any*/)
  ],
  "type": "_xGitHubIssue",
  "abstractKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cloudId",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueKey",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "descriptionHTML",
  "storageKey": null
},
v24 = {
  "kind": "InlineFragment",
  "selections": [
    (v19/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/)
  ],
  "type": "JiraIssue",
  "abstractKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "integration",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v18/*: any*/),
    (v24/*: any*/)
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingId",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "discussionId",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "threadSortOrder",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "threadParentId",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamId",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v34/*: any*/)
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskEditorDetails",
  "kind": "LinkedField",
  "name": "editors",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "task",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/),
    (v2/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/),
    (v31/*: any*/),
    (v32/*: any*/),
    (v7/*: any*/),
    (v33/*: any*/),
    (v35/*: any*/),
    (v6/*: any*/),
    (v36/*: any*/)
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "removedTaskId",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cloudName",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectKey",
  "storageKey": null
},
v41 = [
  (v34/*: any*/)
],
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyHTML",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "_xGitHubRepository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v44/*: any*/)
  ],
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "descriptionHtml",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iid",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webPath",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webUrl",
  "storageKey": null
},
v50 = {
  "kind": "InlineFragment",
  "selections": [
    (v46/*: any*/),
    (v11/*: any*/),
    (v47/*: any*/),
    (v48/*: any*/),
    (v49/*: any*/)
  ],
  "type": "_xGitLabIssue",
  "abstractKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamProject",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskService",
  "storageKey": null
},
v53 = {
  "kind": "InlineFragment",
  "selections": [
    (v19/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/),
    (v39/*: any*/),
    (v40/*: any*/)
  ],
  "type": "JiraIssue",
  "abstractKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationHash",
  "storageKey": null
},
v55 = [
  (v1/*: any*/)
],
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "task",
  "plural": false,
  "selections": (v55/*: any*/),
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "DeleteTaskPayload",
  "kind": "LinkedField",
  "name": "DeleteTaskPayload",
  "plural": false,
  "selections": [
    (v56/*: any*/)
  ],
  "storageKey": null
},
v58 = [
  (v1/*: any*/),
  (v3/*: any*/)
],
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "EditTaskPayload",
  "kind": "LinkedField",
  "name": "EditTaskPayload",
  "plural": false,
  "selections": [
    (v56/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "editor",
      "plural": false,
      "selections": (v58/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEditing",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v55/*: any*/),
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "involvement",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "privatizedTaskId",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "UpdateTaskDueDatePayload",
  "kind": "LinkedField",
  "name": "UpdateTaskDueDatePayload",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v15/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "createdByUser",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "integration",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v18/*: any*/),
    (v24/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "task",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v65/*: any*/),
    (v15/*: any*/),
    (v66/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/),
    (v2/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/),
    (v31/*: any*/),
    (v32/*: any*/),
    (v7/*: any*/),
    (v33/*: any*/),
    (v35/*: any*/),
    (v6/*: any*/),
    (v36/*: any*/)
  ],
  "storageKey": null
},
v68 = [
  (v34/*: any*/),
  (v1/*: any*/)
],
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "_xGitHubRepository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v44/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v70 = {
  "kind": "InlineFragment",
  "selections": [
    (v42/*: any*/),
    (v11/*: any*/),
    (v43/*: any*/),
    (v69/*: any*/)
  ],
  "type": "_xGitHubIssue",
  "abstractKey": null
},
v71 = {
  "kind": "InlineFragment",
  "selections": [
    (v23/*: any*/),
    (v22/*: any*/),
    (v21/*: any*/),
    (v40/*: any*/),
    (v20/*: any*/)
  ],
  "type": "JiraServerIssue",
  "abstractKey": null
},
v72 = [
  (v3/*: any*/),
  (v1/*: any*/),
  (v4/*: any*/)
],
v73 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTaskIntegration"
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isHighlighted",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v3/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v76 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "error",
      "storageKey": null
    }
  ]
},
v77 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "replies",
      "plural": true,
      "selections": [
        (v16/*: any*/),
        (v1/*: any*/),
        (v30/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Threadable",
  "abstractKey": "__isThreadable"
},
v78 = {
  "alias": "createdByUserNullable",
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "createdByUser",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isViewerComment",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "concreteType": "Reactji",
  "kind": "LinkedField",
  "name": "reactjis",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isViewerReactji",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "users",
      "plural": true,
      "selections": (v58/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "createdByUser",
  "plural": false,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TaskSubscriptionPayload",
        "kind": "LinkedField",
        "name": "taskSubscription",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ChangeTaskTeamPayload",
            "kind": "LinkedField",
            "name": "ChangeTaskTeamPayload",
            "plural": false,
            "selections": [
              (v37/*: any*/),
              (v38/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CreateTaskIntegrationPayload",
            "kind": "LinkedField",
            "name": "CreateTaskIntegrationPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "task",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "integration",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/),
                          (v39/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v40/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "JiraRemoteProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": (v41/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "JiraIssue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v42/*: any*/),
                          (v11/*: any*/),
                          (v43/*: any*/),
                          (v45/*: any*/)
                        ],
                        "type": "_xGitHubIssue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v23/*: any*/),
                          (v22/*: any*/)
                        ],
                        "type": "JiraServerIssue",
                        "abstractKey": null
                      },
                      (v50/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v51/*: any*/),
                          (v11/*: any*/),
                          (v20/*: any*/)
                        ],
                        "type": "AzureDevOpsWorkItem",
                        "abstractKey": null
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "TaskIntegrationLinkIntegrationGitHub"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "TaskIntegrationLinkIntegrationJira"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "TaskIntegrationLinkIntegrationJiraServer"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "TaskIntegrationLinkIntegrationGitLab"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "TaskIntegrationLinkIntegrationAzure"
                      }
                    ],
                    "storageKey": null
                  },
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v7/*: any*/),
                  (v1/*: any*/),
                  (v52/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "IntegratedTaskContent_task"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CreateTaskPayload",
            "kind": "LinkedField",
            "name": "CreateTaskPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "task",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "integration",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v17/*: any*/),
                          (v43/*: any*/),
                          (v11/*: any*/),
                          (v45/*: any*/)
                        ],
                        "type": "_xGitHubIssue",
                        "abstractKey": null
                      },
                      (v53/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v47/*: any*/),
                          (v11/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/)
                        ],
                        "type": "_xGitLabIssue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v11/*: any*/),
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AzureDevOpsRemoteProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": (v41/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "AzureDevOpsWorkItem",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v2/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v7/*: any*/),
                  (v33/*: any*/),
                  (v35/*: any*/),
                  (v6/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ThreadedItemReply_threadable"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ThreadedItem_threadable"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "replies",
                    "plural": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ThreadedRepliesList_replies"
                      }
                    ],
                    "storageKey": null
                  },
                  (v54/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v57/*: any*/),
          (v59/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RemoveOrgUserPayload",
            "kind": "LinkedField",
            "name": "RemoveOrgUserPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "updatedTasks",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v2/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v7/*: any*/),
                  (v33/*: any*/),
                  (v35/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v60/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateTaskPayload",
            "kind": "LinkedField",
            "name": "UpdateTaskPayload",
            "plural": false,
            "selections": [
              (v37/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NotifyTaskInvolves",
                "kind": "LinkedField",
                "name": "addedNotification",
                "plural": false,
                "selections": [
                  (v61/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamMember",
                    "kind": "LinkedField",
                    "name": "changeAuthor",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v35/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "NotificationTemplate_notification"
                  },
                  (v1/*: any*/),
                  (v62/*: any*/),
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Task",
                    "kind": "LinkedField",
                    "name": "task",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v9/*: any*/),
                      (v28/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v63/*: any*/)
            ],
            "storageKey": null
          },
          (v64/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TaskSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TaskSubscriptionPayload",
        "kind": "LinkedField",
        "name": "taskSubscription",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ChangeTaskTeamPayload",
            "kind": "LinkedField",
            "name": "ChangeTaskTeamPayload",
            "plural": false,
            "selections": [
              (v67/*: any*/),
              (v38/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CreateTaskIntegrationPayload",
            "kind": "LinkedField",
            "name": "CreateTaskIntegrationPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "task",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "integration",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v1/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v23/*: any*/),
                          (v22/*: any*/),
                          (v19/*: any*/),
                          (v39/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v40/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "JiraRemoteProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": (v68/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "JiraIssue",
                        "abstractKey": null
                      },
                      (v70/*: any*/),
                      (v71/*: any*/),
                      (v50/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v23/*: any*/),
                          (v11/*: any*/),
                          (v51/*: any*/),
                          (v20/*: any*/),
                          (v61/*: any*/)
                        ],
                        "type": "AzureDevOpsWorkItem",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v7/*: any*/),
                  (v1/*: any*/),
                  (v52/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CreateTaskPayload",
            "kind": "LinkedField",
            "name": "CreateTaskPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "task",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v65/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "integration",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v1/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v17/*: any*/),
                          (v43/*: any*/),
                          (v11/*: any*/),
                          (v69/*: any*/)
                        ],
                        "type": "_xGitHubIssue",
                        "abstractKey": null
                      },
                      (v53/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v47/*: any*/),
                          (v11/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/)
                        ],
                        "type": "_xGitLabIssue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v11/*: any*/),
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AzureDevOpsRemoteProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": (v68/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "AzureDevOpsWorkItem",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v2/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v7/*: any*/),
                  (v33/*: any*/),
                  (v35/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "replies",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isThreadable"
                      },
                      (v1/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "createdByUser",
                            "plural": false,
                            "selections": (v72/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "integration",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              (v1/*: any*/),
                              (v73/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v23/*: any*/),
                                  (v22/*: any*/),
                                  (v21/*: any*/),
                                  (v40/*: any*/),
                                  (v39/*: any*/)
                                ],
                                "type": "JiraIssue",
                                "abstractKey": null
                              },
                              (v70/*: any*/),
                              (v71/*: any*/),
                              (v50/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v23/*: any*/),
                                  (v11/*: any*/),
                                  (v51/*: any*/),
                                  (v61/*: any*/),
                                  (v20/*: any*/)
                                ],
                                "type": "AzureDevOpsWorkItem",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v28/*: any*/),
                          (v36/*: any*/),
                          (v2/*: any*/),
                          (v35/*: any*/),
                          (v7/*: any*/),
                          (v74/*: any*/),
                          (v12/*: any*/),
                          (v32/*: any*/),
                          (v15/*: any*/),
                          (v75/*: any*/),
                          (v33/*: any*/),
                          (v31/*: any*/),
                          (v76/*: any*/),
                          (v77/*: any*/)
                        ],
                        "type": "Task",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v78/*: any*/),
                          (v79/*: any*/),
                          (v80/*: any*/),
                          (v81/*: any*/),
                          (v32/*: any*/),
                          (v9/*: any*/),
                          (v31/*: any*/),
                          (v77/*: any*/)
                        ],
                        "type": "Comment",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v54/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "replies",
                        "plural": true,
                        "selections": [
                          (v30/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v16/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v78/*: any*/),
                          (v79/*: any*/),
                          (v80/*: any*/),
                          (v81/*: any*/)
                        ],
                        "type": "Comment",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v82/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "integration",
                            "plural": false,
                            "selections": [
                              (v73/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v42/*: any*/)
                                ],
                                "type": "_xGitHubIssue",
                                "abstractKey": null
                              },
                              (v71/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v46/*: any*/)
                                ],
                                "type": "_xGitLabIssue",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v23/*: any*/),
                                  (v51/*: any*/),
                                  (v61/*: any*/)
                                ],
                                "type": "AzureDevOpsWorkItem",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v36/*: any*/),
                          (v74/*: any*/),
                          (v76/*: any*/)
                        ],
                        "type": "Task",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v82/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PollOption",
                            "kind": "LinkedField",
                            "name": "options",
                            "plural": true,
                            "selections": [
                              (v1/*: any*/),
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "Poll",
                        "abstractKey": null
                      }
                    ],
                    "type": "Threadable",
                    "abstractKey": "__isThreadable"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v57/*: any*/),
          (v59/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RemoveOrgUserPayload",
            "kind": "LinkedField",
            "name": "RemoveOrgUserPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "updatedTasks",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v65/*: any*/),
                  (v15/*: any*/),
                  (v66/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v2/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v7/*: any*/),
                  (v33/*: any*/),
                  (v35/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v60/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdateTaskPayload",
            "kind": "LinkedField",
            "name": "UpdateTaskPayload",
            "plural": false,
            "selections": [
              (v67/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NotifyTaskInvolves",
                "kind": "LinkedField",
                "name": "addedNotification",
                "plural": false,
                "selections": [
                  (v61/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamMember",
                    "kind": "LinkedField",
                    "name": "changeAuthor",
                    "plural": false,
                    "selections": (v72/*: any*/),
                    "storageKey": null
                  },
                  (v35/*: any*/),
                  (v1/*: any*/),
                  (v62/*: any*/),
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Task",
                    "kind": "LinkedField",
                    "name": "task",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v9/*: any*/),
                      (v28/*: any*/),
                      (v2/*: any*/),
                      (v75/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/)
                    ],
                    "type": "Notification",
                    "abstractKey": "__isNotification"
                  }
                ],
                "storageKey": null
              },
              (v63/*: any*/)
            ],
            "storageKey": null
          },
          (v64/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "s_dqcFNRmPWR-WE4oa6YbtWg",
    "metadata": {},
    "name": "TaskSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node ).hash = "cc0fa1fb5557107ffd89aa243d2057d4";

export default node;
